var findIndexOfItemWhereKeyHasTheValue = function (array, key, value) {
	result = -1;
	array.forEach((x, i) => { if (x[key] === value) { result = i; } });
	return result;
}

module.exports = {
	createMapChart: function ($graphblock, data) {

		var legendData = $graphblock.data('chartlegenddata');

		data.forEach(x => x["fill"] = legendData.DataPoints[findIndexOfItemWhereKeyHasTheValue(legendData.DataPoints, "category", x["Segment"])].Fill);

		window.am4core.useTheme(window.am4themes_animated);

		var chart = window.am4core.create($graphblock.attr('id'), window.am4maps.MapChart);

		chart.geodata = am4geodata_swedenHigh;
		// Position map slightly to the left to make some room for the legend on mobile displays
		chart.homeGeoPoint = {
			latitude: 62.1,
			longitude: 22
		};

		chart.projection.d3Projection = am4maps.d3geo.geoTransverseMercator().rotate([-15, 0]);
		// rotate -15 degrees because Sweden is pretty much centered on the 15-degree meridian.
		// Without this rotation, the map tilts...

		var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

		polygonSeries.north = 69; // "North-most latitude of the series", so this value is specific to a map of Sweden.
		// If you want to be able to show any other map, e.g. a world map, this value will need to be computed dynamically.

		polygonSeries.useGeodata = true;

		// data lacks the specific ID we need to map the counties to regions in the geoData, so we need to set those
		data.forEach(x => chart.geodata.features.forEach(y => { if (y.properties.name === x.name) { x["id"] = y["id"]; } }));

		polygonSeries.data = data;
		
		var polygonTemplate = polygonSeries.mapPolygons.template;

		polygonTemplate.tooltipText = "{name}: {Segment}";
		polygonTemplate.nonScalingStroke = true;
		polygonTemplate.strokeWidth = 1.0;
		polygonTemplate.stroke = "#000000";
		polygonTemplate.propertyFields.fill = "fill";

		var hs = polygonTemplate.states.create("hover");
		hs.properties.fill = am4core.color("#000000");

		chart.zoomControl = new am4maps.ZoomControl();
		chart.zoomControl.minusButton.events.on("hit", function (ev) {
			chart.goHome();
		});
		chart.maxZoomLevel = 2;

		chart.legend = new am4maps.Legend();
		chart.legend.position = "right";
		chart.legend.align = "right";
		// Place the legend rougly 1/3 of the width of the chart from the right side
		chart.legend.marginRight = Math.max(0, $graphblock[0].clientWidth / 3 - 100);

		chart.legend.paddingBottom = 7;
		chart.legend.paddingTop = 5;

		chart.legend.background.fill = "#f8f8f8";
		chart.legend.background.fillOpacity = 0.7;

		chart.responsive.enabled = true;

		chart.legend.useDefaultMarker = true;

		var marker = chart.legend.markers.template.children.getIndex(0);
		marker.cornerRadius(0,0,0,0);
		marker.strokeWidth = 1;
		marker.strokeOpacity = 1;
		marker.stroke = am4core.color("#000");
		chart.legend.itemContainers.template.paddingTop = 0;
		chart.legend.itemContainers.template.paddingBottom = 0;

		chart.legend.data = [];
		legendData.DataPoints.forEach(x => chart.legend.data.push({ "name": x["Teckenförklaring"], "fill": x["Fill"] }));
		chart.legend.itemContainers.template.clickable = false;
		chart.legend.itemContainers.template.focusable = false;
		chart.legend.interactionsEnabled = false;

		var legendTitle = chart.legend.createChild(am4core.Label);
		legendTitle.text = $graphblock.data('chartlegendtitle').replaceAll('|', '\n');
		legendTitle.dx = 8.2;

		return chart;
	}
};
